import { LayerTypeId } from "../generated/enums"
import { isResourceAccessible } from "../permissions/holding/accessRestrictions"
import { createMap } from "../utils/array"
import { LayerViewModel } from "./layerViewModel"
import { IDataLayer, SharedLayersService } from "./types"


export function getAvailableLayers<T>(svc: SharedLayersService, layers: T[], selector: (layer: T) => IDataLayer) {

    const fieldsMap = createMap(svc.fields, f => f.fieldId)
    const croppingMap = createMap(svc.cropping, c => c.croppingId)
    const genericPlansMap = createMap(svc.getGenericPlans(svc.yearId), p => p.GenericPlanId)
    const session = svc.getSession()

    const available = layers
        .map(selector)
        .filter(l => {

            if (!l.FieldId) {
                return true
            }

            if (!fieldsMap.has(l.FieldId)) {
                return false
            }

            if (l.TypeId === LayerTypeId.GenericPlan) {

                const cropping = croppingMap.get(l.CroppingId || 0)

                if (cropping && (!cropping.authorized)) {
                    return false
                }

                const plan = genericPlansMap.get(l.GenericPlanId || 0)

                if (plan && (!isResourceAccessible(session, plan))) {
                    return false
                }

            }

            return true

        })

    return available

}